import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/config';
import './LanguageSelector.css';

export const LanguageSelector: React.FC = () => {
  const { t } = useTranslation();

  const handleLanguageChange = (lang: string): void => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };

  return (
    <div className="language-selector">
      <button
        onClick={() => handleLanguageChange('it')}
        className={`btn-language ${i18n.language === 'it' ? 'active' : ''}`}
        aria-label={t('languages.it')}
      >
        IT
      </button>
      <button
        onClick={() => handleLanguageChange('en')}
        className={`btn-language ${i18n.language === 'en' ? 'active' : ''}`}
        aria-label={t('languages.en')}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSelector;
